import { render, staticRenderFns } from "./DocumentFileReport.vue?vue&type=template&id=6135711d&scoped=true"
import script from "./DocumentFileReport.vue?vue&type=script&lang=ts"
export * from "./DocumentFileReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6135711d",
  null
  
)

export default component.exports